'use client';

import type React from 'react';
import { getClassNames } from '@/utils/helpers';
import { Label, Input } from '@yaradigitallabs/ahua-react';

type ManualCorrectionProps = {
  id: string;
  unit: string;
  value: number;
  onChange: (value: number) => void;
  className?: string;
  disabled?: boolean;
};

export const ManualCorrection: React.FC<ManualCorrectionProps> = ({
  id,
  unit,
  value,
  onChange,
  className,
  disabled = false,
}) => {
  return (
    <div
      className={getClassNames(
        'rounded pt-3 pb-0 pb-2 flex flex-col justify-start gap-2',
        className ? className : ''
      ).trim()}
    >
      <div className="pb-2 flex flex-col items-start gap-2 border-b border-gray-200">
        <div className="flex flex-col justify-start">
          <Label maxLineCount={1} size="l" htmlFor={id}>
            Manual correction
          </Label>
        </div>
      </div>
      <div className="flex justify-start items-center gap-4">
        <div className="w-[100px]">
          <Input
            value={value ?? 0}
            size="xs"
            type="number"
            id={id}
            endAdornment={
              <Label htmlFor={id} className="text-sm text-gray-500!">
                {unit}
              </Label>
            }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange(e.target.value ? parseFloat(e.target.value) : 0)
            }
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};
